// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__ZiZfR","emails":"CreateEditClinics_emails__1Obj3","emailTagLabel":"CreateEditClinics_emailTagLabel__1n5ev"};